import { render, staticRenderFns } from "./PublisherInfoDialog.vue?vue&type=template&id=02776450&scoped=true"
import script from "./PublisherInfoDialog.vue?vue&type=script&lang=js"
export * from "./PublisherInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02776450",
  null
  
)

export default component.exports